import axios from 'axios';
import {APIBASE} from '../../config/Pfalzmarkt.config';
import {useEffect, useState} from "react";
import {useStore} from "../../store/store";
import Home from "../Home/Home";
import pmLogo from '../../assets/images/logo-pfalzmarkt.svg';
import * as Icon from "react-bootstrap-icons";

export default function Login(props) {
    const [globalState, dispatch] = useStore();
    const [isLoggedIn, setIsLoggeIn] = useState('false')
    const [error, setError] = useState(null);
    const[showPwClear, setShowPwClear] = useState(false);
    const putItemsInStorage = async () => {
        const header = "Authorization: Bearer " + localStorage.getItem("token");
        try {
            const response = await axios.get(
                APIBASE + 'api/artikel/getAll', {headers: header}
            );
            const data = await response.data;
            localStorage.setItem('items', JSON.stringify(data));

        } catch (err) {
            setError(err.message || 'Ssomething went wrong!');
        }
        try {
            const response = await axios.get(
                APIBASE + 'api/artikel/getAllVariants', {headers: header}
            );
            const data = await response.data;
            localStorage.setItem('itemVariants', JSON.stringify(data));

        } catch (err) {
            setError(err.message || 'Ssomething went wrong!');
        }
    };

    useEffect(() => {
        dispatch('SET_AUTHTOKEN', localStorage.getItem('token'));
    }, [isLoggedIn]);


    function doLogin(event) {
        event.preventDefault();
        var formData = {
            username: event.target.elements.erzeuger.value,
            password: event.target.elements.password.value,
        };

        axios({
            method: 'post',
            url: APIBASE + 'pfalzLogin',
            rejectUnauthorized: false,
            data: formData,
        }).then(result => {
            setIsLoggeIn(true);
            props.setShowModal && props.setShowModal(false);
            dispatch('IS_401_ERROR', false);
            localStorage.setItem('token', result.data.token);
            putItemsInStorage();
        })
            .catch(error => {
                setIsLoggeIn(false);
                localStorage.removeItem('token');
                console.log(error);
            });

    }

    function togglePassword() {
        const pwField = document.getElementById("password");
        pwField.type === "password" ? pwField.type = "text" : pwField.type = "password";
        setShowPwClear(!showPwClear);
    }


    return (
        <>
            {globalState.token && <Home/>}
            {!globalState.token &&
                <form onSubmit={doLogin}>
                    {error && error}
                    {!isLoggedIn && <div className="alert alert-danger" role="alert">Ihr Login
                        hat leider nicht funktioniert. Bitte überprüfen Sie Benutzernamen und
                        Kennwort</div>}

                    <div className="row">
                        <div className="col-3">
                            <img src={pmLogo} alt="Pfalzmarkt für Obst und Gemüse eG"/>
                        </div>
                        <div className="col-3">
                            <label>
                                <p>Erzeuger</p>
                                <input id="erzeuger" name="erzeuger" type="text"/>
                            </label>
                        </div>
                        <div className="col-3">
                            <label>
                                <p onClick={() => {
                                    togglePassword()
                                }}>Passwort {!showPwClear? <Icon.Eye/>: <Icon.EyeSlash/>}</p>
                                <input id="password" name="password" type="password"/>
                            </label>
                        </div>
                        <div className="col-3">
                            <button type="submit">Anmelden</button>
                        </div>
                    </div>
                </form>
            }
        </>
    )
}
